import { Link } from "react-router-dom";
import styled from "styled-components";

export const Section = styled.section`
    width: 100%;
    left: 0;
    right: 0;
    max-width: 1400px;
    margin: 140px auto 0 auto;

    @media (max-width: 768px) {
        margin: 60px auto 0 auto;
    }
`;

export const SectionHeading = styled.h2`
    text-align: center;
`;

export const TextRow = styled.span`
    font-family: Inter, sans-serif;
    font-weight: 500;
    font-size: calc(24px + 1.5vw);
    line-height: calc(32px + 1.631vw);
    display: block;
    text-transform: uppercase;
    
    @media (max-width: 480px) {
        font-size: 32px;
        line-height: 38.73px;
    }

    @media (min-width: 1600px) {
        font-size: 48px;
        line-height: 58.09px;
    }
`;

export const ReputationRow = styled.div`
    width: calc(100% + 200px);
    margin-top: calc(30px + 3.125vw);
    margin-left: -100px;
    display: flex;
    
    &:hover {
        cursor: pointer;
    }
    
    @media (max-width: 768px) {
        width: calc(100% + 32px);
        margin-left: -16px;
    }
`;

export const OpportunityWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 20px;
`

export const OpportunityContainer = styled(Link)`
    width: calc(50% - 10px);
    background-color: #F7F7F7;
    position: relative;
    box-sizing: border-box;
    padding: 24px 20px;
    border-radius: 30px;
    text-decoration: none;
    
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: calc(6px + 0.375vw);

    & > * {
        margin: 0;
        font-family: Inter, sans-serif;
        color: #7F7F7F;
    }

    & > span {
        font-style: Medium;
        font-size: 1.8vw;
        font-weight: 500;
        line-height: calc(8px + 1.65vw);
        letter-spacing: 2%;
        color: #000000;
    }
    & > p {
        font-style: Regular;
        width: calc(100% - 28px);
        font-weight: 400;
        font-size: calc(-1px + 1.32vw);
        line-heigth: calc(-1px + 1.65vw)
    }
    @media (max-width: 768px){
        padding: 16px;
        & > span {
            font-size: 13px;
            line-height: 16px;
        }
        
        & > p {
            font-size: 9px;
            line-height: 12px;
        }
    }

    @media (max-width: 576px){
        width: 100%;
    }
        
    @media (min-width: 1600px){
        gap: 12px;

        & > span {
            font-size: 28px;
            line-height: 32px
        }
        & > p {
            font-size: 20px;
            line-height: 24px;
        }
    }

`

export const ArrowIcon = styled.img`
    position: absolute;
    right: 24px;
    width: calc(1px + 1.68vw);

    @media (max-width: 768px){
        width: 14px;
        right: 16px;
    }

    @media (min-width: 1600px){
        width: 28px;
    }
`